import { gql } from '@apollo/client';
import { VerifyTwoFactorLoginMutation, VerifyTwoFactorLoginMutationVariables } from '../../graphql/types';
import { client } from '../../lib/apollo';

export const TWO_FACTOR_REQUIRED = 'TWO_FACTOR_REQUIRED';
export const TWO_FACTOR_CHALLENGE_EXPIRED = 'TWO_FACTOR_CHALLENGE_EXPIRED';

// where the login and Google sign-in send users with 2FA, after a correct password
export const TWO_FACTOR_LOGIN_PATH = '/login/two-factor';

const VERIFY_TWO_FACTOR_LOGIN = gql`
  mutation VerifyTwoFactorLogin($code: String!) {
    verifyTwoFactorLogin(code: $code) {
      user {
        id
        email
      }
      userHash
    }
  }
`;

export const verifyTwoFactorLogin = async (variables: VerifyTwoFactorLoginMutationVariables) => {
  const result = await client.mutate<VerifyTwoFactorLoginMutation, VerifyTwoFactorLoginMutationVariables>({
    mutation: VERIFY_TWO_FACTOR_LOGIN,
    variables,
    context: {
      credentials: 'include',
      useMetadata: true,
    },
  });

  if (!result.data?.verifyTwoFactorLogin) {
    throw new Error('There was an error signing in. Please try again.');
  }

  return result.data.verifyTwoFactorLogin;
};
